var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-menu-alt-right.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.6666 3.5H2.33329V4.66667H11.6666V3.5ZM9.33329 6.41667H2.33329V7.58333H9.33329V6.41667ZM6.41663 9.33333H2.33329V10.5H6.41663V9.33333Z",
    fill: "#4750A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorIcon);
export default __webpack_public_path__ + "static/media/vector_icon.234a7097b7388a94c80822602664060d.svg";
export { ForwardRef as ReactComponent };